// Loot rolls: a little card for each drop your party is sharing. Need (you'll use it), Greed (you'd like it) or
// Pass; Need beats Greed and the highest roll wins. A leader handing things out sees everyone's names instead.
import { itemDef, rarityOf, RARITY_COLOR } from '../../../shared/items.js';
import type { ServerMsg } from '../../../shared/protocol.js';
import { itemIcon } from '../render/items.js';

type RollMsg = Extract<ServerMsg, { type: 'loot_roll' }>;
type DoneMsg = Extract<ServerMsg, { type: 'loot_done' }>;

export class LootRolls {
  private box: HTMLElement;
  private cards = new Map<number, { el: HTMLElement; timer: number }>();
  onAnswer: (id: number, choice: 'need' | 'greed' | 'pass' | 'give', to?: number) => void = () => {};
  constructor() { this.box = document.createElement('div'); this.box.className = 'loot-rolls'; this.box.setAttribute('aria-live', 'polite'); document.body.append(this.box); }

  add(m: RollMsg): void {
    const d = itemDef(m.def), rar = rarityOf(m.def), el = document.createElement('div'); el.className = 'loot-card'; el.style.borderColor = RARITY_COLOR[rar];
    const icon = itemIcon(m.def).cloneNode() as HTMLCanvasElement; icon.getContext('2d')!.drawImage(itemIcon(m.def), 0, 0);
    const head = document.createElement('div'); head.className = 'loot-head';
    const name = document.createElement('b'); name.textContent = `${d?.name ?? m.def}${m.qty > 1 ? ' ×' + m.qty : ''}`; name.style.color = RARITY_COLOR[rar];
    const sub = document.createElement('small'); sub.textContent = `${rar[0].toUpperCase() + rar.slice(1)} · from ${m.from}`;
    const names = document.createElement('div'); names.append(name, sub); head.append(icon, names);
    const row = document.createElement('div'); row.className = 'loot-row';
    const btn = (label: string, fn: () => void, primary = false) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'btn' + (primary ? ' primary' : ''); b.textContent = label; b.addEventListener('click', () => { fn(); row.querySelectorAll('button').forEach(x => (x as HTMLButtonElement).disabled = true); }); row.append(b); };
    if (m.assign) for (const p of m.assign) btn(`Give to ${p.name}`, () => this.onAnswer(m.id, 'give', p.char));
    else { btn('Need', () => this.onAnswer(m.id, 'need'), true); btn('Greed', () => this.onAnswer(m.id, 'greed')); btn('Pass', () => this.onAnswer(m.id, 'pass')); }
    const bar = document.createElement('i'), fill = document.createElement('em'); bar.append(fill); fill.style.animationDuration = `${m.secs}s`;
    el.append(head, row, bar); this.box.append(el);
    const timer = window.setTimeout(() => this.remove(m.id), (m.secs + 3) * 1000);
    this.cards.set(m.id, { el, timer });
  }
  done(m: DoneMsg): string {
    this.remove(m.id);
    const item = itemDef(m.def)?.name ?? m.def, rolls = m.rolls.filter(r => r.choice !== 'pass').map(r => `${r.name} ${r.choice} ${r.n}`).join(', ');
    return m.to ? `${m.to} got the ${item}${rolls ? ` (${rolls})` : ''}.` : `Nobody wanted the ${item}.`;
  }
  private remove(id: number): void { const c = this.cards.get(id); if (!c) return; clearTimeout(c.timer); c.el.remove(); this.cards.delete(id); }
}
